import { IkyuDayBanner } from '~/components/IkyuDayBanner'
import type { LargeAreaCode } from '~/lib/graphql/scalars'
import { ikyuDayRegionalPagePath } from '~/lib/ikyuDay'
import { css } from '~/styled-system/css'

export function GuideIkyuDayBanner({
  show,
  largeAreaCode,
}: { show: boolean; largeAreaCode: LargeAreaCode }) {
  if (!show) {
    return null
  }
  return (
    <div className={css({ px: '3', pt: '3', _pc: { px: '0', pt: '0' } })}>
      <a
        href={ikyuDayRegionalPagePath(largeAreaCode)}
        className={css({ display: 'block', w: 'full' })}
      >
        <IkyuDayBanner />
      </a>
    </div>
  )
}
